import { create } from "zustand";

import { CurrentCustomer } from "../../../api/estabrookSchemas";
import { Session, emptySession } from "../../../types/models/session";

import { persist } from "zustand/middleware";

export interface AuthStore extends Session {
  isLoggedIn: boolean;
  customer: CurrentCustomer | null;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  setCustomer: (customer: CurrentCustomer | null) => void;
  setSession: (session: Session) => void;
}

const AUTH_STORAGE_KEY = "auth-storage";

const useAuthStore = create<AuthStore>()(
  persist<AuthStore>(
    (setState) => ({
      isLoggedIn: false,
      customer: null,
      ...emptySession,
      setIsLoggedIn: (isLoggedIn) => {
        if (!isLoggedIn) {
          setState({ customer: null, ...emptySession });
        }
        setState({ isLoggedIn });
      },
      setCustomer: (customer: CurrentCustomer | null) => setState({ customer }),
      setSession: (session: Session) => setState(session),
    }),
    { name: AUTH_STORAGE_KEY },
  ),
);

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key !== AUTH_STORAGE_KEY) return;

    if (event.newValue === null) {
      useAuthStore.getState().setIsLoggedIn(false);
      return;
    }

    useAuthStore.persist.rehydrate();
  });
}

export { useAuthStore };
